export enum MessageType {
    Log = 'log',
    Measurement = 'measurement',
}
